import { TextField, useTranslate, useRecordContext } from 'react-admin';
import { useDrawer } from '@/composables/useDrawer';

export const ProductNameField = () => {
    const record = useRecordContext();
    const { openDrawer } = useDrawer();
    const translate = useTranslate();

    return (
        <>
            <TextField
                onClick={() => {
                    openDrawer(record.id, 'product-show');
                }}
                source='name'
                sx={{
                    fontWeight: 'bold',
                    display: 'block',
                    width: '300px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    margin: '-6px 0 2px 0',
                    cursor: 'pointer',
                }}
            />
            <TextField source='ean' label={translate('resources.product.fields.ean')} sx={{ fontSize: '11px !important', display: 'block' }} />
        </>
    );
};
